import React, { useEffect, useState } from 'react';
import Pagination from 'components/atoms/pagination';
import Loader from 'components/atoms/loader';
import { useDispatch, useSelector } from 'react-redux';
import { getFollowups } from 'store/modules/market_store/actions';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import moment from 'moment';
import FollowupstModal from 'components/atoms/followups_modal';

interface FollowupsMarketProps {
  params: any;
}

const FollowupsMarket = (props: FollowupsMarketProps) => {
  const { params } = props;
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [followups, setFollowups] = useState<any>({});

  const { request, bidding } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  useEffect(() => {
    dispatch(getFollowups(params, currentPage));
  }, [params, currentPage]);

  const Followups = (products: object) => {
    setFollowups(products);
    setShowModal(true);
  };

  return (
    <div className="row mt-4">
      <div className="col-md-12">
        <div className="card overflow-auto">
          <div>
            <div className="pl-2 my-2 d-flex align-items-center">
              <i className="material-icons">shopping_cart</i>
              <b className="pl-1 mt-2">Acompanhamentos</b>
            </div>
          </div>
          <ul className="list-group list-group-flush table-responsive">
            {request?.get_followups?.loading ? (
              <Loader />
            ) : (
              <table className="table table-hover table-resultados">
                <thead style={{ backgroundColor: '#EBECEF' }}>
                  <tr>
                    <th scope="col">Edital</th>
                    <th scope="col">Órgão</th>
                    <th scope="col">Síntese</th>
                    <th scope="col">Qnt.</th>
                    <th scope="col">Data da Fonte</th>
                  </tr>
                </thead>
                <tbody>
                  {bidding?.licitacao?.map((bidding) => (
                    <tr
                      key={bidding.licitacao.id}
                      onClick={() => {
                        Followups(bidding);
                      }}
                    >
                      <td>{bidding?.licitacao?.edital}</td>
                      <td>
                        {bidding.licitacao.orgao.nome}
                        <br />
                        <small>
                          {bidding.licitacao.orgao.cidade} / {bidding.licitacao.orgao.estado}
                        </small>
                      </td>
                      <td>
                        {bidding.licitacao.acompanhamentos[0].sintese != null &&
                        bidding.licitacao.acompanhamentos[0].sintese.length > 225
                          ? `${bidding.licitacao.acompanhamentos[0]?.sintese.substring(0, 225)}...`
                          : bidding.licitacao.acompanhamentos[0].sintese}
                      </td>

                      <td>{bidding.licitacao.acompanhamentos.length}</td>
                      <td>
                        {moment
                          .parseZone(bidding.licitacao.acompanhamentos[0].data_fonte)
                          .format('L')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </ul>
          <div className="border rounded-bottom border-top-0 d-print-none">
            <button
              type="button"
              key="btn-bidding-more-info"
              className="btn btn-sm btn-link m-0 w-100 mb-3"
              onClick={() => setBiddingInfoToggle(!BiddingInfoToggle)}
            >
              {BiddingInfoToggle ? 'Ver menos' : 'Ver mais'}
            </button>
            {BiddingInfoToggle && (
              <div className="row d-print-none">
                <div className="col-md-12 px-4 mb-5">
                  <Pagination
                    postsPerPage={10}
                    totalPosts={bidding?.total}
                    paginate={paginate}
                    currentPage={currentPage}
                    firstAndLastPage
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <FollowupstModal showModal={showModal} setShowModal={setShowModal} followups={followups} />
    </div>
  );
};

export default FollowupsMarket;
